import { render, staticRenderFns } from "./MemberIdEdit.vue?vue&type=template&id=87c94cec&"
import script from "./MemberIdEdit.vue?vue&type=script&lang=js&"
export * from "./MemberIdEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports